import Vue from 'vue'
// import store from './store'
import App from './App.vue'
import './registerServiceWorker'
import Buefy from 'buefy'
import router from './router'
import VueEditor from "vue2-editor"
import VueQrcodeReader from "vue-qrcode-reader"
import VueClipboard from 'vue-clipboard2'


// import VueApexCharts from 'vue-apexcharts'
// Vue.component('apexchart', VueApexCharts)

import Datepicker from '@/components/Events/Helper/Datepicker.vue'
Vue.component('Datepicker', Datepicker)

import Rangepicker from '@/components/Events/Helper/Rangepicker.vue'
Vue.component('Rangepicker', Rangepicker)

import Timepicker from '@/components/Events/Helper/Timepicker.vue'
Vue.component('Timepicker', Timepicker)

import draggable from 'vuedraggable'
Vue.component('Draggable', draggable)

Vue.prototype.$l = require('./config/lang/de.json')

// import configDefault from './config/default'
// Vue.prototype.$root.env.config = configDefault

import VuePrismEditor from "vue-prism-editor";
import "vue-prism-editor/dist/VuePrismEditor.css"; // import the styles
Vue.component("prism-editor", VuePrismEditor);

import _sanitize from './components/Events/Helper/sanitize'

Vue.use(VueEditor)

Vue.use(VueClipboard)

Vue.use(VueQrcodeReader)

var moment_ = require('moment')
moment_.locale('de')

Vue.prototype.$moment = moment_

Vue.use(Buefy, {
  defaultIconPack: 'fad',
  customIconPacks: {
    'fal': {
      sizes: {
        'default': 'fa-lg',
        'is-small': 'fa-sm',
        'is-medium': 'fa-lg',
        'is-large': 'fa-2x'
      },
      iconPrefix: 'fa-',
    }
  },
  defaultDateFormatter: (date) => moment_(date).format("LL")
})


Vue.config.productionTip = false


new Vue({
  data: {
    settings: {},
    events: [],
    event: {},
    users: [],
    async getApi(path = 'events', callback = data => data, loading = true) {
      if(loading){
        this.env.loading.public += 1
      }else{
        this.env.loading.active += 1
      }
      await fetch(this.$root.env.config.apiURL + path, {
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': this.env.auth.header()
          })
        })
        .then(res => {
          if (res.ok) {
            return res
          }
          this.env.auth.success = false
          throw new Error('Network response was not ok. Status: ' + res.status);
        })
        .then(stream => stream.json())
        .then(callback)
        .catch(function (error) {
          console.log('There has been a problem with your fetch operation: ', error.message)
        })
      if(loading){
        this.env.loading.public -= 1
      }else{
        this.env.loading.active -= 1
      }
    },
    async postApi(path = 'events', data = {}, callback = data => data, confirm = '', loading = true) {
      if(loading){
        this.env.loading.public += 1
      }else{
        this.env.loading.active += 1
      }
      await fetch(this.$root.env.config.apiURL + path, {
          method: 'POST',
          mode: 'cors', // no-cors, cors, *same-origin
          cache: 'no-cache',
          headers: new Headers({
            'Content-Type': 'application/json',
            'Authorization': this.env.auth.header()
          }),
          body: JSON.stringify(data)
        })
        .then(res => {
          if (res.ok) {
            return res
          }
          this.env.auth.success = false
          throw new Error('Network response was not ok. Status: ' + res.status);
        })
        .then(stream => stream.json())
        .then(callback)
        .then(() => {
          if (confirm != '') {
            this.$buefy.toast.open({
              message: confirm,
              type: 'is-success'
            })
          }
        })
        .catch(function (error) {
          console.log('There has been a problem with your fetch operation: ', error.message)
        })
      if(loading){
        this.env.loading.public -= 1
      }else{
        this.env.loading.active -= 1
      }
      // this.event = this.events.filter(event => event.id == id)[0]
    },
    async uploadAsset(file, callback = (data) => data) {
      this.env.loading.public += 1
      var payload = new FormData();
      payload.append("file", file);
      await fetch(this.$root.env.config.apiURL + 'assets/' + this.$root.event.id, {
          method: 'POST',
          mode: 'cors', // no-cors, cors, *same-origin
          cache: 'no-cache',
          headers: new Headers({
            // 'Content-Type': 'application/json',
            'Authorization': this.$root.env.auth.header()
          }),
          body: payload
        })
        .then(res => {
          if (res.ok) {
            return res
          }
          this.$root.env.auth.success = false
          throw new Error('Network response was not ok. Status: ' + res.status);
        })
        .then(stream => stream.json())
        .then(callback)
        .then(() => {
          if (confirm) {
            this.$buefy.toast.open({
              message: 'Upload erfolgreich!',
              type: 'is-success'
            })
          }
        })
        .catch(function (error) {
          console.log('There has been a problem with your fetch operation: ', error.message)
        })
      this.env.loading.public -= 1
    },
    getEvents() {
      this.getApi('events', data => this.events = data.events)
    },
    createEvent() {
      let d = {
        data: {
          start: this.$moment().format('YYYY-MM-DD'),
          end: this.$moment().format('YYYY-MM-DD')
        }
      }
      this.postApi('event/create', d ,data => {
        if (data.event.id > 0) {
          this.getEvents()
        }
      })
    },
    cloneEvent(id = 0) {
      this.getApi('event/clone/'+id, data => {
        if (data.event.id > 0) {
          this.getEvents()
        }
      })
    },
    deleteEvent(id) {
      this.getApi('event/delete/' + id, data => {
        if (data.success == true) {
          this.getEvents()
        }
      })
    },
    trashEvent(id) {
      this.getApi('event/trash/' + id, data => {
        if (data.success == true) {
          this.getEvents()
        }
      })
    },
    archiveEvent(id) {
      this.getApi('event/archive/' + id, data => {
        if (data.success == true) {
          this.getEvents()
        }
      })
    },
    categorizeEvent(id, category) {
      this.getApi('event/category/' + id + '/' + category, data => {
        if (data.success == true) {
          this.getEvents()
        }
      })
    },
    activateEvent(id) {
      this.getApi('event/activate/' + id, data => {
        if (data.success == true) {
          this.getEvents()
        }
      })
    },
    getEvent(id) {
      this.getApi('event/' + id, data => this.event = data.event)
    },
    async saveEvent(id, confirm = false, loading = true) {
      let conf = confirm ? 'Die Daten wurden gespeichert.' : ''
      const e = _sanitize(this.event)
      await this.postApi('event/' + id, {
        data: e
      }, data => {
        this.event = data.event
        this.env.eventChanged = false
        let today = new Date();
        let h = '00' + today.getHours();
        let m = '00' + today.getMinutes();
        this.env.lastSave = h.slice(-2) + ':' + m.slice(-2)
      }, conf, loading)
    },
    getSettings() {
      this.getApi('settings', data => this.settings = data)
    },
    saveSettings(confirm = false) {
      let conf = confirm ? 'Die Einstellunen wurden gespeichert.' : ''
      this.postApi('settings', {
        settings: this.settings
      }, data => this.settings = data, conf)
    },
    getAccount() {
      this.getApi('account', data => this.env.account = data)
    },
    async postAccount(task = '', data = {}, confirm = false, callback = data => this.env.account = data) {
      let conf = confirm ? 'Die Einstellunen wurden gespeichert.' : ''
      await this.postApi('account/' + task, {
        data: data
      }, callback, conf)
    },
    async getUsers(id, page = 1) {
      this.env.loading.users = true
      let status = 'finished'
      if(page === 1) this.users = []
      await this.getApi('event/' + id + '/users?page='+page, data => {
        if(!Array.isArray(data.users)) data.users = []
        data.users.forEach(entry => {
          if (!entry.data.workshops) {
            entry.data.workshops = {}
          } else if (entry.data.workshops.length == 0) {
            entry.data.workshops = {}
          }

          if (!entry.data.accommodations) {
            entry.data.accommodations = {}
          } else if (entry.data.accommodations.length == 0) {
            entry.data.accommodations = {}
          }

          if (entry.data.checkin.length == 0) {
            entry.data.checkin = {}
          }

          this.users.push(entry)
          return
        })
        if (this.event.counter) {
          this.event.counter.recipients = data.count
        }
        status = data.status
        //status = 'finished'
      }, false)
      if(status === 'continue'){
        await this.getUsers(id, (page+1))
      }else{
        this.env.loading.users = false
        if (this.event.counter) {
          this.event.counter.recipients = this.users.length
          this.saveEvent(id, false, false)
        }
      }


    },
    saveUser(id, data, confirm = false) {
      let appendix = '',
        text = ''
      if (confirm) {
        appendix = '?dialog=true'
        text = ' und benachrichtigt'
      }
      if(data.conflict) delete data.conflict
      this.postApi('user/' + id + appendix, {
        data: data
      }, ret => {
        if(ret.status == 'success'){
          this.$buefy.toast.open({
            message: 'Der Teilnehmer wurde aktualisiert' + text + '.',
            type: 'is-success'
          })
        }else if(ret.conflict){
          data.conflict = ret.conflict
          Object.entries(data.conflict).forEach(([c,d]) => {
            if(data[c.split('_')[0]+'s'][c+'_registered']){
              data[c.split('_')[0]+'s'][c+'_registered'] = false
            }
          })
          this.$buefy.toast.open({
            message: 'Es ist ein Konflikt aufgetreten.',
            type: 'is-danger'
          })
        }
        this.getUsers(this.$route.params.id)
        this.saveEvent(this.$route.params.id)
      })
    },
    env: {
      home: {
        view: 'home'
      },
      init: false,
      config: {},
      lastSave: false,
      account: {},
      eventChanged: false,
      view: {
        tabArrangement: 0,
        tabSettings: 0,
        activeTab: 0,
        tabMapping: [
          '',
          '/edit',
          '/communication',
          '/users',
          '/registration',
        ]
      },
      isLoading: false,
      loading: {
        users: false,
        active: 0,
        public: 0
      },
      auth: {
        success: false,
        credentials: {
          username: '',
          password: ''
        },
        header(user = this.credentials.username, pw = this.credentials.password) {
          let obj = {
            type: "user",
            credentials: [
              user,
              pw
            ]
          }
          return JSON.stringify(obj)
        },
        login(user, password, keepSession = false) {
          if (keepSession) {
            localStorage.setItem('user', JSON.stringify({
              user: [user, password]
            }))
            localStorage.setItem('keepSession', '1');
          } else {
            localStorage.setItem('keepSession', '0');
            sessionStorage.setItem('user', JSON.stringify({
              user: [user, password]
            }))
          }
          this.credentials.username = user
          this.credentials.password = password
          this.success = true
        },
        logout() {
          localStorage.removeItem('keepSession')
          localStorage.removeItem('user')
          sessionStorage.removeItem('user')
          this.credentials.username = ''
          this.credentials.password = ''
          this.success = false
          return true
        },
        getAuth() {
          let user
          if (localStorage.getItem('keepSession') == '1') {
            user = localStorage.getItem('user')
          } else {
            user = sessionStorage.getItem('user')
          }
          if (user === null) {
            return {}
          }
          user = JSON.parse(user)
          this.credentials.username = user.user[0]
          this.credentials.password = user.user[1]
          this.success = true
        }
      }
    },
    uuid(){
      function b(a){return a?(a^Math.random()*16>>a/4).toString(16):([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g,b)}
      return b()
    }
  },

  methods: {
    updatedEvent() {
      this.env.eventChanged = true
    },
    updateArrangementTab() {
      if (this.$route.name == 'eventpage') {
        let h = this.env.view.tabMapping.findIndex(r => r == '/' + this.$route.params.page)
        this.env.view.activeTab = h > 0 ? h : 0
      } else if (this.$route.name == 'event') {
        this.env.view.activeTab = 0
      }
    }
  },

  beforeCreate: async function () {
    fetch(process.env.BASE_URL + "env.json")
      .then(stream => stream.json())
      .then(stream => this.env.config = stream)
      .then(stream => this.env.init = true)
      .catch(function (error) {
        console.log('There has been a problem with your fetch operation: ', error.message)
      })
  },

  created() {
    // fetch the data when the view is created and the data is
    // already being observed
    this.env.auth.getAuth()
  },

  watch: {
    // call again the method if the route changes
    // '$route': 'update',
    'event': 'updatedEvent',
    '$route.params.page': 'updateArrangementTab'
  },

  router,
  // store,
  render: h => h(App)
}).$mount('#app')
